<template>
    <span>
        {{ this.fixedImei }}
    </span>
</template>

<script>
export default {
    props: ['imei'],
    computed: {
        fixedImei: function () {
            if(this.imei)
                return 'X-' + this.imei.substring(this.imei.length-4);
            else return ''
        }
    },
}
</script>